import { useTranslation } from 'react-i18next'

import Button from '../../../Button'
import { PageEmptyState } from '../../../PageEmptyState'
import {
  APPLICANTS_RETRY_ACTION_NAME,
  QA_NAME_APPLICANTS_RETRY,
} from '../RentalPortalApplicants.constants'

import RefreshIcon from '../../../../icons/refresh.svg'
import UsersIcon from '../../../../icons/users-1.svg'

function RentalPortalApplicantsLoadError({ isRefetching, onRetry }) {
  const { t } = useTranslation()

  return (
    <PageEmptyState
      EntityIcon={UsersIcon}
      actions={[
        {
          Component: Button.Flat,
          beforeIconProps: { Icon: RefreshIcon },
          isLoading: isRefetching,
          name: APPLICANTS_RETRY_ACTION_NAME,
          qaName: QA_NAME_APPLICANTS_RETRY,
          text: t('RentalPortal.ListingRetryBtnKey'),
          onClick: onRetry,
        },
      ]}
      text={t('RentalPortal.ListingProfileApplicantsLoadErrorKey')}
    />
  )
}

export default RentalPortalApplicantsLoadError
